import React from 'react';
import PropTypes from 'prop-types';
import CleanLayoutStyled, { LogoWomStyled } from './styles/CleanLayoutStyled';

const CleanLayout = ({ children, withLogoHeader }) => {
  return (
    <CleanLayoutStyled>
      <aside />
      {withLogoHeader && (
        <header>
          <LogoWomStyled />
        </header>
      )}
      <section>{children}</section>
    </CleanLayoutStyled>
  );
};

CleanLayout.propTypes = {
  children: PropTypes.node.isRequired,
  withLogoHeader: PropTypes.bool,
};

CleanLayout.defaultProps = {
  withLogoHeader: false,
};

export default CleanLayout;
